import gql from 'graphql-tag';
import { dwellerAccessMediaTypesAvailableFragment } from '../fragments';

export const dweller = gql`
  query dweller($personId: Int!) {
    dweller(personId: $personId) {
      personId
      name
      email
      phone
      creationDate
      canChangeEmail
      isAlmahIntegrated
      reducedMobility
      devices {
        id
        type
        value
        counter
        lastCounter
        blocked
        description
        lastAccessDateTime
        lastAcessPlace
        facialStatus
        fingerIndex
        finger
        panic
        mobile {
          os
          version
          name
          gadgetInfo
        }
      }
      documents {
        id
        value
        documentTypeId
      }
      additionalContacts {
        id
        personId
        contactTypeId
        contact
      }
    }
  }
`;

export const documentTypes = gql`
  query documentTypes {
    documentTypes {
      id
      name
      origin
      mask
    }
  }
`;

export const expectedGuestsByDweller = gql`
  query expectedGuestsByDweller(
    $personContextId: Int!
    $filters: GuestQueryInput
  ) {
    expectedGuestsByDweller(
      personContextId: $personContextId
      filters: $filters
    ) {
      collection {
        inviteId
        hostName
        createPersonInvite
        inviteName
        startDate
        endDate
      }
      pagination {
        totalPages
        totalResults
        page
        pageSize
      }
    }
  }
`;

export const dwellerAccessMediaTypesAvailable = gql`
  query dwellerAccessMediaTypesAvailable($personId: Int!, $isUpdate: Boolean) {
    dwellerAccessMediaTypesAvailable(personId: $personId, isUpdate: $isUpdate) {
      ...dwellerAccessMediaTypesAvailableParts
    }
  }
  ${dwellerAccessMediaTypesAvailableFragment}
`;

export const accessProfilesByDweller = gql`
  query accessProfilesByDweller($personContextId: Int!) {
    accessProfilesByDweller(personContextId: $personContextId) {
      id
      name
    }
  }
`;

export const vehiclesByDweller = gql`
  query vehiclesByDweller($personId: Int!) {
    vehiclesByDweller(personId: $personId) {
      id
      plate
      model
      type
      tag
      creationDate
      color
      colorName
    }
  }
`;

export const vehicleColors = gql`
  query vehicleColors {
    vehicleColors {
      id
      name
    }
  }
`;

export const temporaryAccessPlaces = gql`
  query temporaryAccessPlaces($personContextId: ID!) {
    temporaryAccessPlaces(personContextId: $personContextId) {
      id
      name
    }
  }
`;
